import { create } from 'zustand';

type ScreenState = {
  isExpanded: boolean;
  toggleExpand: () => void;
};

const useScreenStore = create<ScreenState>((set) => ({
  isExpanded: false,
  toggleExpand: () => set((state) => ({ isExpanded: !state.isExpanded }))
}));

export default useScreenStore;
